import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import Loading from "../../components/loading/loading";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const { loading } = useSelector((state: any) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/all-orders");
  }, []); // eslint-disable-line

  return (
    <>
      <Typography>Dashboard Page</Typography>
      {loading && <Loading />}
    </>
  );
}
